import { css } from '@emotion/react';

export const imageStyles = css`
  width: 100%;
  height: 275px;
  border-radius: var(--radius-lg);
  object-fit: cover;
  object-position: center;
`;
